import { MenuItem, Select } from '@mui/material';
import {
  ConditionOperation,
  ConditionValueType,
} from 'api/models/FieldTemplate';
import { useTranslation } from 'react-i18next';
import { getOperatorByType } from 'utils';

interface ConditionOperationSelectProps {
  operation: ConditionOperation;
  onChange: (operation: ConditionOperation) => void;
  type?: ConditionValueType;
  disabled?: boolean;
}

export default function ConditionOperationSelect({
  operation,
  onChange,
  type,
  disabled,
}: ConditionOperationSelectProps) {
  const { t } = useTranslation();
  const operators = getOperatorByType(type);

  return (
    <Select
      disabled={disabled}
      sx={{ width: '100%' }}
      value={operation}
      onChange={e => onChange(e.target.value as ConditionOperation)}
    >
      {operators.map(operator => (
        <MenuItem key={`condition-operator-${operator}`} value={operator}>
          {t(`export.conditionOperation.${operator}`)}
        </MenuItem>
      ))}
    </Select>
  );
}
